export default __webpack_public_path__ + "static/media/systemowe7.06dd67c6.jpg";